import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getUserId = () => localStorage.getItem("handoff_user_id");
export const setUserId = (id) => localStorage.setItem("handoff_user_id", id);
export const clearUserId = () => localStorage.removeItem("handoff_user_id");

export const api = {
  login: async () => {
    const { data } = await client.get("/auth/google/login");
    return data;
  },
  me: async (userId) => {
    const { data } = await client.get(`/auth/me`, { params: { user_id: userId } });
    return data;
  },
  logout: async (userId) => {
    await client.post(`/auth/logout`, null, { params: { user_id: userId } });
  },
  listAccounts: async (userId) => {
    const { data } = await client.get(`/ads/accounts`, { params: { user_id: userId } });
    return data;
  },
  listMccClients: async (userId, mccId) => {
    const { data } = await client.get(`/ads/accounts/${mccId}/clients`, { params: { user_id: userId } });
    return data;
  },
  generateBriefing: async (payload) => {
    const { data } = await client.post(`/briefings/generate`, payload);
    return data;
  },
  getJob: async (jobId) => {
    const { data } = await client.get(`/briefings/jobs/${jobId}`);
    return data;
  },
  previewPmaxCsv: async (jobId, file) => {
    const form = new FormData();
    form.append("file", file);
    const { data } = await client.post(`/briefings/jobs/${jobId}/pmax_csv/preview`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },
  submitPmaxCsv: async (jobId, { file, skip }) => {
    const form = new FormData();
    form.append("skip", skip ? "true" : "false");
    if (file && !skip) form.append("file", file);
    const { data } = await client.post(`/briefings/jobs/${jobId}/pmax_csv`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },
  rateBriefing: async (briefingId) => {
    const { data } = await client.post(`/briefings/${briefingId}/rate`);
    return data;
  },
  pitchDeck: async (briefingId) => {
    const { data } = await client.post(`/briefings/${briefingId}/pitch`);
    return data;
  },
  strategyPlan: async (briefingId) => {
    const { data } = await client.post(`/briefings/${briefingId}/strategy`);
    return data;
  },
  exportBriefingXlsx: async (briefingId) => {
    const res = await client.get(`/briefings/${briefingId}/export.xlsx`, { responseType: "blob" });
    return res.data;
  },
  getBriefing: async (briefingId, userId) => {
    const { data } = await client.get(`/briefings/${briefingId}`, {
      params: userId ? { user_id: userId } : {},
    });
    return data;
  },
  listBriefings: async (userId) => {
    const { data } = await client.get(`/briefings/`, { params: { user_id: userId } });
    return data;
  },
  getShared: async (token) => {
    const { data } = await client.get(`/share/${token}`);
    return data;
  },
  chat: {
    list: async (briefingId) => {
      const { data } = await client.get(`/chat/${briefingId}`);
      return data;
    },
    send: async (payload) => {
      const { data } = await client.post(`/chat/`, payload);
      return data;
    },
  },
};
